import Model  from '@/util/models';
import Dapil  from './Dapil';

export default class Kompetisi extends Model { 
    backend = '/frc/kompetisi/'; 
    
    modes(){
      return this.api.get(this.backend + 'modes').then(res => {
        return res.status === 200 ? res.data : [];
      })
    }
    
    tingkats(){       
      return this.api.get('/frc/area/' + 'tingkats').then(res => {
        return res.status === 200 ? res.data : [];
      })
    }  
    
    areas(params){
      return this.api.get('/frc/area/' + 'index',params).then(res => {
        return res.status === 200 ? res.data : [];
      })
    }
    
    dapils(params){
      let model = new Dapil();
      return model.all(params);
    }
    
    kompetisiDapils(params){
      return this.api.get(this.backend + 'kompetisi-dapils', params).then(res => {
        return res.status === 200 ? res.data : [];
      })
    }
}

